import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarketTicker from "./components/MarketTicker";
import About from "./components/About";
import MarketInfo from "./components/MarketInfo";
import TelegramVIP from "./components/TelegramVIP";
import Disclaimer from "./components/Disclaimer";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

const TELEGRAM_URL = "https://t.me/+jWqpmsdHc_gzYzVk";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar telegramUrl={TELEGRAM_URL} />
      <main>
        <Hero telegramUrl={TELEGRAM_URL} />
        <MarketTicker />
        <About />
        <MarketInfo />
        <TelegramVIP telegramUrl={TELEGRAM_URL} />
        <Disclaimer />
        <FAQ />
        <Contact telegramUrl={TELEGRAM_URL} />
      </main>
      <Footer telegramUrl={TELEGRAM_URL} />
    </div>
  );
}

export default App;
